import { cx } from '@emotion/css'
import React from 'react'

export interface IconChevronRightTNProps {
    className?: string
}

export const IconChevronRightTN: React.FC<IconChevronRightTNProps> = ({
    className,
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={cx(className, 'icon-chevron-right-tn')}
    >
        <path
            d="M9 18L15 12L9 6"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="transparent"
        />
    </svg>
)
IconChevronRightTN.displayName = 'IconChevronRightTN'
